// Box score: acumulador por atleta e por time.
//
// Duas decisoes que vem de dor antiga:
//
// 1. Os campos sao numeros planos e SOMAVEIS. Somar duas linhas e somar 15
//    inteiros -- nada de recalcular derivados na hora de agregar.
// 2. `accumulateInto` existe para os LIDERES DE ESTATISTICA serem
//    INCREMENTAIS. Recalcular cestinhas varrendo a temporada inteira a cada
//    partida e o padrao que travou 4,6s numa virada de rodada no projeto
//    anterior. Aqui a temporada e atualizada em O(atletas do jogo).

/** Campos acumulaveis de uma linha de box score. */
export const STAT_FIELDS = [
  'seconds', 'pts', 'fgm', 'fga', 'tpm', 'tpa', 'ftm', 'fta',
  'orb', 'drb', 'ast', 'stl', 'blk', 'tov', 'pf', 'plusMinus',
];

export function makeStatLine(extra = {}) {
  const line = {};
  for (const f of STAT_FIELDS) line[f] = 0;
  return Object.assign(line, extra);
}

/** Soma `src` em `dst` no lugar. Devolve `dst`. */
export function accumulateInto(dst, src) {
  for (const f of STAT_FIELDS) dst[f] += src[f] || 0;
  return dst;
}

/** Derivados de exibicao. Nunca armazenados -- sempre calculados na leitura. */
export function derive(line, games = 1) {
  const g = games || 1;
  return {
    games: g,
    min: line.seconds / 60,
    minPerGame: line.seconds / 60 / g,
    ptsPerGame: line.pts / g,
    rebPerGame: (line.orb + line.drb) / g,
    astPerGame: line.ast / g,
    reb: line.orb + line.drb,
    fgPct: line.fga ? line.fgm / line.fga : 0,
    threePct: line.tpa ? line.tpm / line.tpa : 0,
    ftPct: line.fta ? line.ftm / line.fta : 0,
    // True shooting: a metrica que realmente diz se o cara arremessa bem.
    tsPct: line.fga || line.fta
      ? line.pts / (2 * (line.fga + 0.44 * line.fta))
      : 0,
  };
}

/** Totais do time a partir das linhas individuais. */
export function teamTotals(lines) {
  const total = makeStatLine();
  for (const line of lines) accumulateInto(total, line);
  return total;
}

/** Formata minutos como MM:SS, do jeito que uma sumula mostra. */
export function formatMinutes(seconds) {
  const m = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}
